import type { MessageFunction } from 'vue-i18n';
import homepage from './pages/homepage/index';
import tech from './pages/tech/index';
import statistics from './pages/statistics/index';
import Info from './pages/info/index';
import system from './pages/system/index';
// 克罗地亚
export default {
    license: {
        powered_by: 'SAIC Motor International {\'|\'} Sva prava pridržana',
    },
    auth: {
        login: 'Prijava',
        username: 'Korisničko ime',
        username_placeholder: 'Unesite korisničko ime',
        password: 'Lozinka',
        password_placeholder: 'Unesite lozinku',
        code: 'Verifikacijski kod',
        code_placeholder: 'Unesite verifikacijski kod',
        logout: 'Odjava',
        logout_success: 'Uspješno ste se odjavili',
        day: 'dan',
        password_expiration: 'Lozinka je istekla – molimo promijenite je',
        expire: 'Preostalo dana do isteka lozinke',
        conseils:
            'Mora sadržavati velika slova, mala slova, brojke i posebne znakove ({msg}). Duljina lozinke mora biti između 8 i 16 znakova.',
        brand_Selection: 'Odabir marke',
        unread_notices: 'Nepročitane obavijesti',
        new_cases: 'Novi slučajevi',
        unanswered_cases: 'Neodgovoreni slučajevi',
        overdue_cases: 'Zakašnjeli slučajevi',
    },
    button: {
        query: 'Upit',
        editing_position: 'Uredi poziciju',
        show_theme_editor: 'Prikaži/sakrij uređivač teme',
        change_password: 'Promijeni lozinku',
        old_password: 'Stara lozinka',
        new_password: 'Nova lozinka',
        confirm_password: 'Potvrdi lozinku',
        button: 'Gumb',
        about: 'O programu',
        back: 'Natrag',
        go: 'U redu',
        home: 'Početna stranica',
        confirm: 'Potvrdi',
        modify: 'Izmijeni',
        edit: 'Uredi',
        new: 'Novo',
        cancel: 'Odustani',
        close: 'Zatvori',
        search: 'Pretraži',
        reset: 'Poništi',
        delete: 'Izbriši',
        add: 'Dodaj',
        collapse: 'Sažmi',
        expand: 'Proširi',
        download_template: 'Preuzmi predložak',
        batch_import: 'Grupni uvoz',
        import: 'Uvezi',
        export: 'Izvezi',
        export_fail: 'Uvoz nije uspio',
        detailed: 'Detalji',
        details: 'Pojedinosti',
        download: 'Preuzmi',
        toView: 'Pregledaj',
        toViews: 'Pregledaj slike',
        uploadAttachments: 'Prenesi privitke',
        selectFile: 'Odaberite datoteku',
        fillingInstructions: 'Upute za popunjavanje',
        release: 'Objavi',
        release_recall: 'Povuci objavu',
        save: 'Spremi',
        send: 'Pošalji',
        tips: 'Savjeti',
        send_back: 'Vrati',
        examine: 'Pregledaj',
        void: 'Poništi',
        more: 'Više',
        refresh: 'Osvježi',
        selects: 'Odaberite',
        serial_number: 'Redni broj',
        upload_progress: 'Napredak prijenosa',
        invalid: 'Nevaljano',
        daily_record: 'Dnevnik',
        operation_type: 'Vrsta operacije',
        field_name: 'Naziv polja',
        edit_role: 'Uredi ulogu',
        user_role: 'Odaberite ulogu',
        assignment_role: 'Uloga',
        post: 'Radno mjesto',
        sending: 'Slanje u tijeku...',
        reset_password: 'Poništi lozinku',
        display_or_not: 'Prikazati ili ne',
        document: 'Dokument',
        specificTemplates: 'Posebni predlošci',
        transferOrder: 'Prenos narudžbe',
        forwarding: 'Proslijedi',
        one_click_notification: 'Obavijest jednim klikom',
        english_export: 'Izvoz na engleskom',
        oneclick_download: 'Preuzimanje jednim klikom',
        passwordmsga:
            'Mora sadržavati velika slova, mala slova, brojke i posebne znakove (@\\$!_~\\&*)',
        passwordmsgb: 'Duljina lozinke mora biti između 8 i 16 znakova',
        passwordmsgc: 'Ne smije biti ista kao bilo koja od posljednjih šest lozinki',
        export_file_list: 'Popis izvezenih datoteka',
        personal_center: 'Osobni centar',
        upload_list: 'Popis prijenosa',
        clear_completed: 'Očisti dovršeno',
    },
    radio: {
        enabled: 'Omogućeno',
        disabled: 'Onemogućeno',
        catalogue: 'Katalog',
        individual: 'Pojedinačno',
        all: 'Sve',
        yes: 'Da',
        no: 'Ne',
    },
    dropdown: {
        close_others: 'Zatvori ostale',
        close_right: 'Zatvori desno',
        close_left: 'Zatvori lijevo',
    },
    table: {
        action: 'Radnja',
        explain: 'Objašnjenje',
        fileName: 'Naziv datoteke',
        size: 'Veličina (MB)',
        uploader: 'Prenositelj',
        uploadTime: 'Vrijeme prijenosa',
        system: 'Sustav',
        caption: 'Naslov',
        categorization: 'Kategorizacija',
        link: 'Poveznica',
        forwarding_time: 'Vrijeme proslijeđivanja',
        forwarder: 'Proslijedio',
        send_to: 'Pošalji za',
        mode: 'Način rada',
    },
    pagination: {
        pages: ({ named }: Parameters<MessageFunction>[0]) => `Stranica ${named('number')}`,
        total: ({ named }: Parameters<MessageFunction>[0]) => `Ukupno ${named('number')} zapisa`,
        vinCount: ({ named }: Parameters<MessageFunction>[0]) => `Ukupno ${named('number')} vozila`,
    },
    confirm: {
        confirm_deletion: 'Potvrditi brisanje?',
        confirm_void: 'Potvrditi poništavanje?',
        confirm_release: 'Potvrditi objavu?',
        ack: 'Potvrdi',
        cancel: 'Odustani',
        non_records: 'Odaberite barem jedan zapis',
    },
    request: {
        failed_placeholder: 'Zahtjev nije uspio – pogreška na poslužitelju',
        success_placeholder: 'Zahtjev je uspio',
        auth: {
            login_success: 'Uspješna prijava',
        },
        error: {
            '404': 'Tražena putanja ne postoji',
            '403': 'Nedovoljne ovlasti',
        },
    },
    page: {
        global: {
            page_search: 'Pretraživanje stranice',
        },
        error: {
            not_found: 'Stranica nije pronađena',
            not_found_des: 'Ovdje nema ništa',
            auth_failed: 'Nedovoljne ovlasti',
            auth_failed_des: 'Pristup ovoj stranici je zabranjen',
            file_format_error: 'Nevažeći format datoteke!',
            preview_failed: 'Pretpregled nije uspio! Datoteka je oštećena!',
        },
        homepage: {
            homepage: homepage.homepage.hrHR,
        },
        system: {
            menu: system.menu.hrHR,
            dict: system.dict.hrHR,
            dept: system.dept.hrHR,
            role: system.role.hrHR,
            user: system.user.hrHR,
        },
        info: {
            announcement: Info.announcement.announcement.hrHR,
            document: Info.document.document.hrHR,
        },
        tech: {
            quality: {
                problemTracking: tech.quality.problemTracking.hrHR,
                recallActivity: tech.quality.recallActivity.hrHR,
                abnormalClaimTracking: tech.quality.abnormalClaimTracking.hrHR,
            },
            management: {
                inquiryOd: tech.management.inquiry.hrHR,
                permission: tech.management.permission.hrHR,
                onSiteSupportHq: tech.management.onSiteSupport.hrHR,
                progHistoryHq: tech.management.progHistory.hrHR,
                salesRecordHq: tech.management.salesRecord.hrHR,
                vehicleInfoHq: tech.management.vehicleInfo.hrHR,
                claimHq: tech.management.claim.hrHR,
                filterHq: tech.management.filter.hrHR,
                newCarlssue: tech.management.newCarIssue.hrHR,
                newCarDefinition: tech.management.newCarDefinition.hrHR,
                vehicleProductionInfo: tech.management.vehicleProductionInfo.hrHR,
                programmingHistoryInformationQuery:
                    tech.management.programmingHistoryInformationQuery.hrHR,
                ecuControllerInformationQuery: tech.management.ecuControllerInformationQuery.hrHR,
            },
        },
        components: {
            businessComponents: tech.management.businessComponents.hrHR,
        },
        statistics: statistics.inquiryStatistics.hrHR,
        systemClassifyA: statistics.systemClassifyA.hrHR,
        systemClassifyB: statistics.systemClassifyB.hrHR,
        engineerStatistics: statistics.engineerStatistics.hrHR,
        defectivePart: statistics.defectivePart.hrHR,
        replyInquiryStatistics: statistics.replyInquiryStatistics.hrHR,
        passRateStatistics: statistics.passRateStatistics.hrHR,
        timelyResponseRateStatistics: statistics.timelyResponseRateStatistics.hrHR,
        responseRateStatistics24Hour: statistics.responseRateStatistics24Hour.hrHR,
        customsClearance135Rate: statistics.customsClearance135Rate.hrHR,
        accumulatedClosureRate: statistics.accumulatedClosureRate.hrHR,
        engineerAffiliatedOrganization: statistics.engineerAffiliatedOrganization.hrHR,
        EngineerResponseRateReport: statistics.EngineerResponseRateReport.hrHR,
    },
    validation: {
        common: {
            required: 'Ovo polje je obavezno',
            numeric: 'Mora biti cijeli broj',
            decimal: 'Mora biti broj',
            positive_interger: 'Mora biti pozitivan cijeli broj',
            up_to_digits: ({ named }: Parameters<MessageFunction>[0]) =>
                `Najviše ${named('number')} znamenaka`,
            more_than_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `Ne smije premašivati ${named('number')} znakova`,
            max_bytes: ({ named }: Parameters<MessageFunction>[0]) =>
                `Premašuje maksimalni broj znakova (${named('number')})`,
            less_than_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `Najmanje ${named('number')} znakova`,
            must_be_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `Mora imati točno ${named('number')} znakova`,
            greater_than: ({ named }: Parameters<MessageFunction>[0]) =>
                `Ne smije biti veće od ${named('number')}`,
            less_than: ({ named }: Parameters<MessageFunction>[0]) =>
                `Ne smije biti manje od ${named('number')}`,
            up_to_2_decimal_places: 'Najviše 2 decimale',
            retain_up: 'Najviše 10 znamenaka prije decimalne točke, najviše 2 decimale',
            retain_ups: 'Najviše 11 znamenaka prije decimalne točke, najviše 4 decimale',
            input_number: 'Unesite arapske brojeve',
            only_number_a: 'Dopuštena su samo slova ili brojevi',
            translate: 'Dopuštena su samo slova',
            positive_integer: 'Unesite barem jedno polje',
            at_least_one: 'Popunite barem jedno',
        },
        tip: {
            incomplete_information: 'Podaci nisu potpuno ispunjeni',
        },
    },
    import: {
        template_file: 'Predložak datoteke',
        browse: 'Pregledaj',
        download_template: 'Preuzmi predložak',
        no_file_selected: 'Nije odabrana datoteka',
        incorrect_file_type: 'Nevažeća vrsta datoteke',
        exceed: 'Prekoračenje',
        upload_success: 'Prijenos uspio',
        upload_fail: 'Prijenos nije uspio',
        again_upload:
            'Dopušteni su samo slikovni formati: jpg, png, bmp ili gif. Pokušajte ponovno.',
        attachmentUpload: 'Prijenos privitaka',
        otherAttachmentUpload: 'Prijenos ostalih privitaka',
        supportedFormats: 'Podržani formati',
        preview: 'Pretpregled',
    },
    export: {
        noDataToExport: 'Nema podataka za izvoz',
    },
    select: {
        all: 'Sve',
    },
    checkbox: {
        select_all: 'Odaberi sve',
    },
    dialog: {
        error_message: 'Poruka o pogrešci',
        one_year: 'Može se izvesti najviše godinu dana podataka odjednom',
    },
    ymd: {
        year: 'godina',
        month: 'mjesec',
        day: 'dan',
        week: 'tjedan',
        january: 'siječanj',
        february: 'veljača',
        march: 'ožujak',
        april: 'travanj',
        may: 'svibanj',
        june: 'lipanj',
        july: 'srpanj',
        august: 'kolovoz',
        september: 'rujan',
        october: 'listopad',
        november: 'studeni',
        december: 'prosinac',
    },
};
